import * as React from "react"
import { useContext, useEffect, useState } from "react";
import { IconButton } from "@mui/material"
import { Link } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Box from "@mui/system/Box"
import Menu from '@mui/material/Menu';
import SelectMenuItem from '@mui/material/MenuItem';
import Select from "@mui/material/Select"
import styled from "@emotion/styled";
import { AgreementContext } from "./AgreementContext";
import { CustomThemeContext } from "./themes/CustomThemeContext";

interface Sb1HeaderProps {
    agreement: string
    onLogout: () => void
    menuItems: {name: string, path: string, isActive: boolean}[]
}

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`

const LogoContainer = styled.button`
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
`

const MenuGroup = styled.ul`
  text-align: center;
  background-color: #fff;
`

const MenuItem = styled.li`
  display: inline-block;
  margin: 0 8px;
`
interface MenuLinkProps {
  isActive: boolean
}

const MenuLink = styled(Link)<MenuLinkProps>`
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: ${props => props.isActive ? "bold" : "normal"};
  text-decoration: none;
  color: #000;
  &:active {
    color: #00ff00;
  }
  &:hover {
    color: #002776;
    text-decoration: underline;
  }
`

export const Sb1Header: React.FC<Sb1HeaderProps> = ({agreement, menuItems, children, onLogout}) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [anchorEl, setAnchorEl] = useState(null);
    const {currentTheme, setCurrentTheme} = useContext(CustomThemeContext)

    const onClickLogo = () => {

    }
    
    useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
    }, []);

    const handleMenu = (event: any) => {
        console.log(event.currentTarget)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
      setAnchorEl(null);
    };
    
    const {agreements} = useContext(AgreementContext)

    
    return (
        <header>
            <HeaderContainer>
                <LogoContainer className='h-3/4 cursor-pointer' onClick={onClickLogo}>
                    <img
                      src={currentTheme.logo}
                      alt='Logo'
                      className='h-full'
                      style={{height: "40px", maxWidth: "200px"}}
                    />
                </LogoContainer>
                <Box sx={{flexGrow: 1}}/>
                <IconButton color="primary" aria-label="Kontoinformasjon" component="span" onClick={handleMenu}>
                    <AccountCircleIcon />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    { /*<SelectMenuItem key={"user_settings"}onClick={handleClose}>Brukerinstillinger</SelectMenuItem> */ }
                    <SelectMenuItem key={"log_out"} onClick={onLogout}>Logg ut</SelectMenuItem>  
                </Menu>
                { children }
            </HeaderContainer>
            { menuItems.length > 0 && <nav>
                <MenuGroup style={{display: "block"}}>
                  { menuItems.map (itm => (
                    <MenuItem key={itm.name}><MenuLink to={`${itm.path}`} isActive={itm.isActive}>{itm.name}</MenuLink></MenuItem>
                  ))}
                </MenuGroup>
            </nav>
            }
        </header>
    )
}

export const SB1Toolbar: React.FC<Sb1HeaderProps> = ({agreement}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  const onClickLogo = () => {

  }

  const handleMenu = (event: any) => {
      console.log(event.currentTarget)
      setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const {agreements} = useContext(AgreementContext)

  return (
    <HeaderContainer>
      <LogoContainer onClick={onClickLogo}>
          <img
            src={width && width < 640 ? "https://fakturasalg.sb1finans.no/wp-content/uploads/rgb_SB1_Finans_SMN_verti_pos.png" : "https://fakturasalg.sb1finans.no/wp-content/uploads/rgb_SB1_Finans_SMN_verti_pos.png"}
            alt='Logo'
            style={{height: "40px", maxWidth: "200px"}}
          />
      </LogoContainer>
      <Box sx={{flexGrow: 1}}/>
      <IconButton color="primary" aria-label="Kontoinformasjon" component="span" onClick={handleMenu}>
          <AccountCircleIcon />
      </IconButton>
      <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
      >
          <SelectMenuItem key={"user_settings"}onClick={handleClose}>Brukerinstillinger</SelectMenuItem>
          <SelectMenuItem key={"log_out"} onClick={handleClose}>Logg ut</SelectMenuItem>  
      </Menu>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={agreement}
        label="Agreement"
        sx={{height: "40px"}}
      >
        { agreements?.map(agreement => <SelectMenuItem key={agreement.id} value={agreement.id}><Link to={`/avtale/${agreement.id}`}>{agreement.name}</Link></SelectMenuItem>) }
      </Select>
    </HeaderContainer>
  )
}

export const SB1MenuBar: React.FC<Sb1HeaderProps>= ({children, menuItems}) => {
  return (
    <nav>
      <MenuGroup style={{display: "block"}}>
                  { menuItems.map (itm => (
                    <MenuItem key={itm.name}><MenuLink to={`${itm.path}`} isActive={itm.isActive}>{itm.name}</MenuLink></MenuItem>
                  ))}
      </MenuGroup>
    </nav>
  )
}

export default Sb1Header